const social = {
  linkedIn: 'https://www.linkedin.com/in/marian-gibala-785b0358/',
  github: 'https://github.com/mariangibala',
  hackerRank: 'https://www.hackerrank.com/mgibala',
  stackOverflow: 'https://stackoverflow.com/users/3511096/marian-gibala',
  twitter: 'https://twitter.com/MarianGibala',
  blog: 'https://blog.mgibala.com'
};

export default social;


// WEBPACK FOOTER //
// ./src/utils/social.js